export interface CanvasProps {
  width: number;
  height: number;
  className?: string;
}

export class Canvas {
  public readonly canvas: HTMLCanvasElement;
  public readonly ctx: CanvasRenderingContext2D | null;

  static MIN_SIZE = 1;

  constructor({ width, height, className }: CanvasProps) {
    this.canvas = document.createElement('canvas');

    if (className) {
      this.canvas.className = className;
    }

    this.ctx = this.canvas.getContext('2d', { willReadFrequently: true });

    this.setWidth(width);
    this.setHeight(height);
  }

  public getWidth(): number {
    return this.canvas.width;
  }

  public setWidth(width: number): void {
    this.canvas.width = width > Canvas.MIN_SIZE ? width : Canvas.MIN_SIZE;
  }

  public getHeight(): number {
    return this.canvas.height;
  }

  public setHeight(height: number): void {
    this.canvas.height = height > Canvas.MIN_SIZE ? height : Canvas.MIN_SIZE;
  }

  public getImageData(): ImageData | null {
    const width = this.getWidth();
    const height = this.getHeight();

    if (this.ctx && width > 0 && height > 0) {
      return this.ctx.getImageData(0, 0, width, height);
    }

    return null;
  }
}

export default Canvas;
